export const ellipsisSx = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

// สีพื้นหลังแถวหัวคอลัมน์ (ลำดับ/Expense Id/งาน-รหัสงบ/ยอดเบิก/รายละเอียด/อนุมัติ) ให้ตัดกับแถวข้อมูล
// ชัดเจน — ใส่ตรงที่ TableCell แต่ละอันเอง (ไม่ใช่ที่ TableRow) เพราะตารางเปิด stickyHeader ไว้ MUI
// sticky แต่ละ cell แยกกัน ถ้าใส่สีที่ TableRow เฉยๆ พอ scroll ผ่านพื้นหลังจะโปร่งใสมองทะลุเห็นแถวข้อมูลได้
export const HEADER_CELL_SX = {
  bgcolor: 'primary.main',
  color: '#fff',
  fontWeight: 700,
};
